module.exports = __webpack_public_path__ + "06_mole.8251dfb1.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/okuta/son/layer2/06_mole.png
// module id = hKia
// module chunks = 0